module.exports = __webpack_public_path__ + "static/media/IMG_1094.7fd11b1a.png";